import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Common } from 'ws-scripts/modules/common';
import { setClassNames } from '../utils/utility';
import { INSTANT_EPRICE_DISABLED_POPOVER } from '../constants/labels';

const InstantEPriceButton = props => {
	const {
		isModalVisible,
		loadingUserProfile,
		userLoggedIn,
		handleClick,
		buttonLabel,
		pendingLabel,
		vehicleId,
		vehicleCategory,
		pageAlias,
		buttonStyle,
		buttonMobileClass,
		disabled,
		preventMultipleEpriceLeads
	} = props;

	const formUrl =
		`/instant-eprice-form.htm?itemId=${vehicleId}&vehicleId=${vehicleId}&category=${vehicleCategory}` +
		`&parentPageAlias=${pageAlias}&vcdaInstantEPrice`;

	const allowLeadSubmission = () => {
		// Don't submit a lead if preventMultipleEpriceLeads preference is set and user
		// has already submitted one
		return !(
			preventMultipleEpriceLeads &&
			window.DDC.userProfile.ePriceVehicles &&
			window.DDC.userProfileController.hasUserContactData()
		);
	};

	const submitLeadConditionally = () => {
		if (allowLeadSubmission()) {
			window.DDC.userProfileController.sendLeadForm(formUrl);
		}
	};

	const openModalOrSubmitLead = () => {
		try {
			handleClick();
		} catch (error) {
			throw new Error('Unable to handle click.');
		} finally {
			submitLeadConditionally();
		}
	};

	const nonModalLogIn = userLoggedIn && !isModalVisible;
	const dataHrefAttr = nonModalLogIn ? null : formUrl;

	// if the user is logged in, we don't want to trigger a dialog in mobile (slide-in) or desktop (modal)
	const dialogClass = nonModalLogIn ? 'slidein-disabled' : 'dialog';
	const buttonDisplayClass = isModalVisible ? 'd-none' : '';
	const modalDisplayClass = isModalVisible ? '' : 'd-none';

	const spinningGears = loadingUserProfile ? (
		<i className="mr-3 ddc-icon ddc-icon-loading ddc-icon-animate-spin" />
	) : null;

	const buttonAllClassNames = setClassNames(
		'btn-block',
		'btn',
		`btn-${buttonStyle}`,
		'instant-eprice',
		`${dialogClass}`,
		`${buttonDisplayClass}`
	);
	const pendingLabelClassNames = setClassNames(
		'instanteprice-pending',
		'font-weight-bold',
		'text-success',
		'text-center',
		`${modalDisplayClass}`
	);
	const tooltip = (
		<Tooltip className="tooltip" id="tooltip" style={{ color: 'red' }}>
			<Common
				render={({ labels }) => {
					return labels.get(INSTANT_EPRICE_DISABLED_POPOVER);
				}}
			/>
		</Tooltip>
	);
	const disabledButton = (
		<div className="disabled">
			<OverlayTrigger
				placement="left"
				overlay={tooltip}
				trigger={['hover', 'click']}
			>
				<div
					key="epriceButtonContainer"
					className={`instantEPriceButton mb-sm-4 ${buttonMobileClass}`}
				>
					<button
						className={buttonAllClassNames}
						data-width="600px"
						data-location="vehicle-eprice-button"
						disabled
					>
						{buttonLabel}
					</button>
				</div>
			</OverlayTrigger>
		</div>
	);
	const regularButton = (
		<div>
			<div
				key="epriceButtonContainer"
				className={`instantEPriceButton mb-sm-4 ${buttonMobileClass}`}
			>
				<button
					className={buttonAllClassNames}
					onClick={openModalOrSubmitLead}
					rel="nofollow"
					data-vehicle-uuid={vehicleId}
					data-href={dataHrefAttr}
					data-width="600px"
					data-location="vehicle-eprice-button"
				>
					{spinningGears}
					{buttonLabel}
				</button>
				<div key="label" className={pendingLabelClassNames}>
					{pendingLabel}
				</div>
			</div>
		</div>
	);

	return disabled ? disabledButton : regularButton;
};

InstantEPriceButton.propTypes = {
	isModalVisible: PropTypes.bool.isRequired,
	disabled: PropTypes.bool.isRequired,
	loadingUserProfile: PropTypes.bool.isRequired,
	userLoggedIn: PropTypes.bool.isRequired,
	buttonLabel: PropTypes.string.isRequired,
	pendingLabel: PropTypes.string.isRequired,
	handleClick: PropTypes.func.isRequired,
	vehicleId: PropTypes.string.isRequired,
	vehicleCategory: PropTypes.string.isRequired,
	pageAlias: PropTypes.string.isRequired,
	buttonStyle: PropTypes.string.isRequired,
	buttonMobileClass: PropTypes.string.isRequired,
	preventMultipleEpriceLeads: PropTypes.bool.isRequired
};

export default InstantEPriceButton;



// WEBPACK FOOTER //
// ./src/components/InstantEPriceButton.jsx